<template>
  <svg
    aria-hidden="true"
    tabindex="-1"
    role="presentation"
    class="icon icon-twitter"
    viewBox="0 0 32 32"
  >
    <path
      fill="#000"
      d="M29.833,7.414c-1.02,0.451-2.11,0.755-3.259,0.896c1.186-0.709,2.073-1.826,2.497-3.141 c-1.114,0.663-2.333,1.128-3.605,1.377c-1.071-1.148-2.573-1.8-4.144-1.8c-3.51,0-6.26,3.066-5.528,6.975 c-4.566-0.226-8.821-2.385-11.699-5.938c-1.505,2.598-0.733,5.918,1.764,7.585c-0.938-0.023-1.817-0.281-2.579-0.708v0.07 c0,2.703,1.905,5.032,4.554,5.568c-0.487,0.131-0.99,0.198-1.495,0.198c-0.364,0-0.721-0.035-1.067-0.105 c0.743,2.313,2.875,3.899,5.304,3.944c-2.377,1.87-5.403,2.716-8.406,2.351c2.584,1.683,5.603,2.575,8.687,2.568 c10.451,0,16.393-8.629,16.142-16.899c1.11-0.805,2.07-1.801,2.831-2.942L29.833,7.414z"
    />
  </svg>
</template>
<script>
export default {};
</script>
